const SESSION_HEADER = 'x-frameio-session-id';

class Session {
  private static instance: Session;

  /**
   * Unique session identifier
   */
  private sessionId: string;

  constructor() {
    this.sessionId = crypto.randomUUID();
  }

  /**
   * The Session class is exported as a Singleton.
   * On instantiation it generateds a unique sessionId which
   * is sent as a header on all requests.
   *
   * Each browser tab/window represents a unique session, and will generate it's own unqiue sessionId.
   *
   * The worker and main thread both share the same sessionId.
   *
   * @returns The Session instance
   */
  public static getInstance(): Session {
    if (!Session.instance) {
      Session.instance = new Session();
    }

    return Session.instance;
  }

  /**
   * Sets the Session ID, identifying the current web-app "Session" (for example - a unique browser tab)
   *
   * @environments client
   * @param [sessionId] the Session ID to set
   */
  public setSessionId(sessionId: string): void {
    this.sessionId = sessionId;
  }

  /**
   * Gets the Session ID (representing a unique web-app instance or "Session", for example - a specific browser tab)
   *
   * @environments client, server
   * @returns the Session ID for the current Session
   */
  public getSessionId(): string {
    return this.sessionId;
  }

  /**
   * Configures sessionId headers to be used in the Api client.
   *
   * @returns sessionId headers
   */
  public getSessionHeaders(): { [SESSION_HEADER]: string } {
    return {
      [SESSION_HEADER]: this.getSessionId(),
    };
  }
}

export const session = Session.getInstance();
